import { type FC } from 'react';

import { StyledDot, StyledLoader } from './Loader.styled';
import type { LoaderProps } from './types';

const ANIMATION_DELAYS = [0, 0.16, 0.32];

const Loader: FC<LoaderProps> = ({ className }) => (
  <StyledLoader className={className}>
    {ANIMATION_DELAYS.map((delay) => (
      <StyledDot key={delay} style={{ animationDelay: `${delay}s` }} />
    ))}
  </StyledLoader>
);

Loader.displayName = 'Loader';

export default Loader;
